// 引入加载函数
import { loadCss, loadModules } from 'esri-loader'
import { REPLACE_ORIGIN, REPLACE_HOSTNAME } from '@/config'

// 基本地图所需的模块名列表
const modules = [
  'esri/Map',
  'esri/config',
  'esri/Graphic',
  'esri/views/MapView',
  'esri/geometry/Point',
  'esri/geometry/Extent',
  'esri/layers/GraphicsLayer',
  'esri/geometry/SpatialReference'
]

// geoserver模块
const GeoModules = [
  "esri/layers/WebTileLayer",
  "esri/layers/support/TileInfo"
]

export default {
  props: {
    zoom: { // 地图缩放层级
      type: [String, Number],
      default: 6
    },
    origin: { // nacos接口部署地址
      type: String,
      default: window.location.origin
    },
    nacos: { // nacos接口获取相关地图配置
      type: String,
      default: "/gateway/api/wgfw-v1/api/gis"
    }
  },
  data () {
    return {
      // 配置相关变量
      modules,
      gisConfig: {
        static: {}, // 地图加载相关资源地址
        map: {} // 地图相关配置参数
      },
      gisConstructor: {},
      SR: {},
      // 基础地图相关变量
      map: null,
      baseMaps: [],
      view: {},
      graphicsLayer: null, // 默认绘图层
      groupGraphicMap: {}, // 组合点位id映射
      graphicsActiveLayer: null, // 高亮绘图层
      mapLayerMap: {},
      // 测量占位变量防止报错
      showCoordinate: false,
      currentMeasureType: '',
      coordinateTarget: {},
      mapLoading: false
    }
  },
  computed: {
    mapRandomId () {
      return `j_map_${parseInt(Math.random() * 100)}_${Date.now()}`
    }
  },
  methods: {
    // 初始化
    async _configMap () {
      // 加载css资源
      loadCss(this.gisConfig.static.css)
      // 合并模块
      this.modules = [
        ...GeoModules,
        ...this.modules,
        ...(this.drawModules || []),
        ...(this.measureModules || []),
        ...(this.queryModules || []),
        ...(this.layerModules || [])
      ]
      // 加载js资源
      const modules = await loadModules(this.modules, {
        url: this.gisConfig.static.js
      }).catch(error => {
        throw new Error(error)
      })
      for (let index in this.modules) {
        // 分割模块字符串获取最后的模块名
        let name = this.modules[index].split('/').pop()
        // 生成模块函数映射
        this.gisConstructor[name] = modules[index]
      }
      // 读取地图设置生成实例
      const mapOptions = this.gisConfig.map.mapOptions
      this.SR = new this.gisConstructor.SpatialReference(mapOptions.spatialReference) // "spatialReference": {"wkid": "4490"}
      // 配置字体库地址
      if (this.gisConfig.static.font) this.gisConstructor.config.fontsUrl = this.gisConfig.static.font
    },
    // 载入geoserver地图
    _loadMap () {
      this.map = new this.gisConstructor.Map()
      const tileInfo = new this.gisConstructor.TileInfo(this.gisConfig.map.tileInfo)
      // const center = new this.gisConstructor.Point(109.894345933182, 19.0377360783462, this.SR)
      const mapServerConfig = this.gisConfig.map.baseMaps || []
      for (const map of mapServerConfig) {
        const options = {
          tileInfo,
          id: map.label,
          value: map.label,
          visible: map.visible,
          urlTemplate: `${map.url}?SERVICE=WMTS&request=GetTile&version=1.0.0&LAYER=${map.identifier}&tileMatrixSet=${map.tileMatrixSet}&TileMatrix=${map.tileMatrixSet}:{level}&TileRow={row}&TileCol={col}&style=&format=image/png`,
          spatialReference: this.SR
        }
        const layer = new this.gisConstructor.WebTileLayer(options)
        // 渲染基础地图列表
        this.baseMaps.push(options)
        this.map.layers.add(layer)
      }
      this.view = new this.gisConstructor.MapView({
        // center,
        map: this.map,
        zoom: this.zoom,
        spatialReference: this.SR,
        container: this.mapRandomId,
        extent: new this.gisConstructor.Extent(this.gisConfig.map.extent)
      })
    },
    // 绑定交互事件
    _bindMapEvent () {
      // 基础地图左键点击事件（包含图层点击）
      this.view.on('click', (event) => {
        this.JMapClick(event)
        this._bindLayerEvent(event)
      })
      this.view.on('drag', (event) => {
        this.JMapDrag(event)
      })
      this.view.on('blur', (event) => {
        this.JMapBlur(event)
      })
      this.view.on('double-click', (event) => {
        this.JMapDoubleClick(event)
      })
      this.view.on('focus', (event) => {
        this.JMapFocusClick(event)
      })
      this.view.on('mouse-wheel', (event) => {
        this.JMapMouseWheel(event)
      })
    },
    // 绑定图层点击事件 （可获取自定义存储的点位信息）
    _bindLayerEvent (event) {
      // 根据基础地图点击查询图层传递
      this.view.hitTest(event).then(this.JMapLayerClick)
    },
    createGrahics () {
      this.graphicsLayer = new this.gisConstructor.GraphicsLayer({ title: '绘制层', graphics: [] })
      this.graphicsActiveLayer = new this.gisConstructor.GraphicsLayer({ title: '高亮绘制层', graphics: [] })
      this.map.add(this.graphicsLayer)
      this.map.add(this.graphicsActiveLayer)
    },
    async _getMapConfig () {
      this.mapLoading = true
      const { data } = await this.$http.get(`${this.origin}${this.nacos}`)
      if (data.status !== 'yes') return console.warn(`nacos地址请求异常，错误信息${data.msg || data.message || '网络请求异常'}`)
      let jsonStr = data.data || JSON.stringify(this.gisConfig)
      jsonStr = jsonStr.replaceAll('REPLACE_ORIGIN', REPLACE_ORIGIN).replaceAll('REPLACE_HOSTNAME', REPLACE_HOSTNAME)
      this.gisConfig = JSON.parse(jsonStr)
    },
    async createMap () {
      await this._getMapConfig()
      await this._configMap()
      this._loadMap()
      this._bindMapEvent()
      this.createGrahics() // 创建默认制图层（可根据场景绘制多个）
      this.createGeoserverOperationLayer && this.createGeoserverOperationLayer() // geo网格、专题图层添加
      this.createResourceDraw && this.createResourceDraw() // 资源绘画功能
      this.createQueryTask && this.createQueryTask() // 地图查询任务
    },
    // 建立地图层映射
    buildMapLayer () {
      for (const map of this.baseMaps) {
        this.mapLayerMap[map.id] = this.map.findLayerById(map.id)
      }
    },
    // 根据id设置图层可见,隐藏其他图层
    showLayerById (id) {
      if (this.mapLayerMap[id].visible) return
      for (const mapId in this.mapLayerMap) {
        if (mapId === id) {
          this.mapLayerMap[mapId].visible = true
        } else {
          this.mapLayerMap[mapId].visible = false
        }
      }
    }
  }
}
